import React, { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  WorkOutline,
  AssignmentOutlined,
  EventOutlined,
  ViewWeekOutlined,
  SchoolOutlined,
} from "@material-ui/icons";
import { formatDate } from "utils";
import { BackendJob } from "components/EditJob";
import {
  ContentContainer,
  JobInfoGrid,
  JobInfoItem,
  IconWrapper,
  ItemContent,
  ItemTitle,
  ItemValue,
} from "./JobInfo.styles";
import { TopBarRedesigned } from "components/TopBarRedesigned";
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData'
import updateLocale from 'dayjs/plugin/updateLocale'

interface JobInfoProps {
  job?: BackendJob;
}

const JobInfoPage: FC = () => {
  const history = useHistory();
  const location = useLocation<{ job: BackendJob }>();
  const job = location.state?.job;
  const basis = ['Permanent', 'Maternity Leave', 'Contact'];
  dayjs.extend(localeData)
  dayjs.extend(updateLocale)
  dayjs.updateLocale('en', {
    weekdaysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun"]
  })

  return (
    <div>
      <TopBarRedesigned
        title={'Job Details'}
        onBack={history.goBack}
      />
      <ContentContainer>
        <JobInfoGrid>
          <JobInfoItem>
            <IconWrapper $iconType="role">
              <WorkOutline />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Role</ItemTitle>
              <ItemValue>{job.position}</ItemValue>
            </ItemContent>
          </JobInfoItem>
          <JobInfoItem>
            <IconWrapper $iconType="contract">
              <AssignmentOutlined />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Contract</ItemTitle>
              <ItemValue>{job.basis !== undefined ? basis[job.basis] : ''}</ItemValue>
            </ItemContent>
          </JobInfoItem>
          <JobInfoItem>
            <IconWrapper $iconType="startDate">
              <EventOutlined />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Start Date</ItemTitle>
              <ItemValue>{job.startDate ? formatDate(job.startDate) : ''}</ItemValue>
            </ItemContent>
          </JobInfoItem>
          <JobInfoItem>
            <IconWrapper $iconType="role">
              <ViewWeekOutlined />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Days Needed</ItemTitle>
              <ItemValue>{job.daysOfWeek
                  ? job.daysOfWeek.split(',').reduce<string[]>((acc, day, index) => {
                      const days = dayjs.weekdaysShort()
                      if (day === '1') {
                        acc.push(days[index]);
                      }
                      return acc;
                    }, []).join(' / ')
                  : ''
              }</ItemValue>
            </ItemContent>
          </JobInfoItem>
          <JobInfoItem>
            <IconWrapper $iconType="experience">
              <SchoolOutlined />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Minimum Experience</ItemTitle>
              <ItemValue>{job.minYearsExp !== undefined ? `${job.minYearsExp} years` : ''}</ItemValue>
            </ItemContent>
          </JobInfoItem>
        </JobInfoGrid>
        
        <JobInfoItem $backgroundType="jobTitle">
            <IconWrapper $iconType="jobTitle">
              <WorkOutline />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Job Title</ItemTitle>
              <ItemValue>{job.title || ''}</ItemValue>
            </ItemContent>
        </JobInfoItem>
        <JobInfoItem $backgroundType="jobDescription">
            <IconWrapper $iconType="experience">
              <SchoolOutlined />
            </IconWrapper>
            <ItemContent>
              <ItemTitle>Job Description</ItemTitle>
              <ItemValue>{job.description || ''}</ItemValue>
            </ItemContent>
        </JobInfoItem>
      </ContentContainer>
    </div>
  );
}

export default JobInfoPage;